import { AdCallResolver, AdUnit, ResolvedAdUnit } from '@mp-commons/modules/ads/AdUnit.js';
import { ComposableResolver } from '@mp-commons/modules/ads/adcall/ComposableResolver.js';
import { UserAdsData } from "@mp-commons/modules/ads/adcall/composable/UserAdsData.js";
import { RandomReplacer } from "@mp-commons/modules/ads/adcall/composable/CommonFiltersAndReplacers.js";
import { ExternallyPassedContentAdData, ContentSpecificAdData } from "@mp-commons/modules/ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { UTMAdCallFilter } from "@mp-commons/modules/ads/adcall/composable/UTMAdCallFilter.js";
import { AdPlacementFilter } from "@mp-commons/modules/ads/adcall/composable/AdPlacementFilter.js";
import { getTestCallFilter } from "@mp-commons/modules/ads/adcall/composable/TestAdCallFilter.js";
import { AdCallParams } from '@mp-commons/modules/ads/AdCallParams.js';
import { VideoPolicyRules } from '@mp-commons/modules/ads/vprules/VideoPolicyRules.js';
import { IMAUnmuter, UserGestureUnmuter } from '@mp-commons/modules/ads/ima/UserGestureUnmuter.js';
import { VideoInfoRawData } from '@mp-commons/model/video/VideoInfo.js';


export function ResolverBuilder(window: Window,
    videoPolicy: VideoPolicyRules,
    contentSpecificAdData: ContentSpecificAdData,
    unmuter?: UserGestureUnmuter,
    imaUnmuter?: IMAUnmuter,
    extdata?: ExternallyPassedContentAdData,
    // detected?: DetectedWebView,
    ud?: UserAdsData,
    enableTestAdCallParam?: boolean
): AdCallResolver {

    const composable = new ComposableResolver();
    composable.registerReplacer(RandomReplacer);
    composable.addParamsFilter(contentSpecificAdData, 1);
    composable.addParamsFilter(ud, 5);
    composable.addParamsFilter(new UTMAdCallFilter(window), 6);
    composable.addParamsFilter(getTestCallFilter(enableTestAdCallParam ? enableTestAdCallParam : false), 9);
    composable.addParamsFilter(new AdPlacementFilter(videoPolicy, extdata?.embedType,unmuter, imaUnmuter));

    return function (u: AdUnit, info: VideoInfoRawData, startingParams: AdCallParams): ResolvedAdUnit {
        return composable.resolver(u, info, startingParams);
    }



}